import { render, staticRenderFns } from "./NewordersPage.vue?vue&type=template&id=fa8f9496"
import script from "./NewordersPage.vue?vue&type=script&lang=js"
export * from "./NewordersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports